module.exports = "/_next/static/images/features-storefront-f6f895e3cc674b739dc9db53a8fe052e.png";